import { jsx } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Box } from "braid-design-system";
import { align, grid } from "./Grid.css.mjs";
const Grid = ({
  children,
  align: align$1,
  className
}) => /* @__PURE__ */ jsx(
  Box,
  {
    className: [grid, className],
    style: assignInlineVars({
      [align]: align$1
    }),
    children
  }
);
export {
  Grid
};
